import { PATHS } from './route-constants';
import { accessOptions } from '@/domain/global.enum';

export const HTTP_CONFIGURATION = {
  defaultHeaders: {
    'Content-Type': 'application/json',
    Authorization: process.env.VUE_APP_AUTHORIZATION,
  },
  defaultTimeout: 180000,
};

export const ALL_ACCESS_OPTIONS = [
  {
    optionCode: accessOptions.DASHBOARD,
    icon: 'mdi-view-dashboard',
    path: PATHS.dashboard.pathBase,
  },
  {
    optionCode: accessOptions.GENERATE_TICKETS,
    icon: 'mdi-ticket-account',
    path: PATHS.ticket.pathBase,
    items: [
      {
        optionCode: accessOptions.VIRTUAL_TICKET,
        path: `${PATHS.ticket.pathBase}${PATHS.ticket.generateVirtualTicket}`,
      },
      {
        optionCode: accessOptions.PRESENTIAL_TICKET,
        path: `${PATHS.ticket.pathBase}${PATHS.ticket.generatePresentialTicket}`,
      },
    ],
  },
  {
    optionCode: accessOptions.BOX,
    icon: 'mdi-account-box',
    path: PATHS.box.pathBase,
    items: [
      {
        optionCode: accessOptions.ASSIGNMENT_BOX,
        path: `${PATHS.box.pathBase}${PATHS.box.assignmentBox}`,
      },
      {
        optionCode: accessOptions.ATTENTION_BOX,
        path: `${PATHS.box.pathBase}${PATHS.box.attentionBox}`,
      },
    ],
  },
  {
    optionCode: accessOptions.RESERVATION,
    icon: 'mdi-calendar',
    path: PATHS.reservation.pathBase,
    items: [
      {
        optionCode: accessOptions.VIRTUAL_RESERVATION,
        path: `${PATHS.reservation.pathBase}${PATHS.reservation.virtualReservation}`,
      },
    ],
  },
];
